import { Icon, type Navigate } from "@omnabase/ui";

/** The pencil beside a views column heading (one management screen, the founder, 2026-10-12: "a single edit symbol beside the heading"):
 *  a link to the area's management screen (the collections, the channels), its name for screen readers and as its tooltip. */
export function ManageLink({ label, href, onNavigate }: { label: string; href: string; onNavigate: Navigate }) {
  return <a className="ob-btn ob-btn--icon ob-btn--sm" href={href} aria-label={label} title={label} onClick={(e) => onNavigate(href, e)}><Icon name="pen" size="md" /></a>;
}
